<template>
  <VueEcharts :option="option" />
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
import { i18nTranslateInit } from '@/utils/utility-lang'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { VueEcharts },
  inject: ['theme'],
  props: ['data', 'name'],
  data() {
    return {
      useOpenCC: i18nTranslateInit.useOpenCC
    }
  },
  computed: {
    option() {
      return {
        grid: {
          top: postcssPatch(40),
          left: 0,
          right: 0,
          bottom: postcssPatch(50)
        },
        legend: [
          {
            data: [
              {
                name: this.useOpenCC(this.name),
                icon: 'rect'
              },
              {
                name: this.$t('同比'),
                icon: 'circle'
              }
            ],
            left: 0,
            itemWidth: postcssPatch(8),
            itemHeight: postcssPatch(8),
            textStyle: {
              color: this.theme['--font-color-2']
            }
          }
        ],
        xAxis: [
          {
            type: 'category',
            inverse: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: this.theme['--border-color-3']
              }
            },
            axisTick: { show: false },
            axisLabel: {
              show: true,
              interval: 0,
              color: this.theme['--font-color-3'],
              formatter(value) {
                return value
              }
            }
          }
        ],
        yAxis: [
          {
            show: false,
            splitLine: {
              show: false
            }
          },
          {
            show: false,
            splitLine: {
              show: false
            }
          }
        ],
        dataset: {
          source: this.data
        },
        series: [
          {
            name: this.useOpenCC(this.name),
            type: 'bar',
            encode: {
              x: 'xAxis',
              y: 'barValue'
            },
            barWidth: postcssPatch(23),
            itemStyle: {
              color: '#FF9933'
            },
            label: {
              show: true,
              position: 'top',
              color: this.theme['--font-color-2'],
              formatter: ({ value }) => {
                return this.$digitjs(value.barValue).convert()
              }
            }
          },
          {
            name: this.$t('同比'),
            type: 'line',
            connectNulls: true,
            encode: {
              x: 'xAxis',
              y: 'lineValue'
            },
            symbol: 'circle',
            symbolSize: 5,
            yAxisIndex: 1,
            itemStyle: {
              color: '#E54C4B',
              borderWidth: postcssPatch(1),
              borderColor: '#E54C4B'
            },
            lineStyle: {
              width: postcssPatch(1)
            }
          }
        ]
      }
    }
  }
}
</script>
